module.exports = __webpack_public_path__ + "static/img/rank_201.f1d3d31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_201.png
// module id = x2X4
// module chunks = 0